import * as z from "zod"
import { FPCType, AccountType } from "@prisma/client"

export const FulfillmentPartnerConfigurationModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  label: z.string(),
  type: z.nativeEnum(FPCType),
  account_as_fulfillment_partner_id: z.number().int(),
  is_allowed_all_origins: z.boolean().nullish(),
  is_allowed_all_airlines: z.boolean().nullish(),
  is_allowed_all_requestors: z.boolean().nullish(),
  account_types: z.nativeEnum(AccountType).array(),
  is_allowed_all_account_types: z.boolean().nullish(),
  trucking_providers: z.string().array(),
  is_allowed_all_providers: z.boolean().nullish(),
  is_restricted: z.boolean(),
  /**
   * [TenantId]
   */
  tenant_id: z.string(),
})
